module.exports = __webpack_public_path__ + "img/detail-collapsed-short.e3c99b12.svg";